export default __webpack_public_path__ + "static/media/50t.ffcf6ee5.jpg";